import { getPreloaderFnContext } from '@confluence/query-preloader-tools';

import { getRemoteLocalStorage } from './getRemoteLocalStorage';

export async function preloadLocalStorage() {
	return getRemoteLocalStorage(await getPreloaderFnContext());
}
